import { Badge } from "antd"
import React from "react"

import { CardComponent } from "../../../components/Card/CardComponent.tsx"
import { cn } from "../../../utils/cn.ts"

interface PortalSectionProps {
  title: React.ReactNode
  /** A small numbered badge next to the title — real counts only (e.g. the
   * number of outstanding attention items), never a placeholder. */
  count?: number
  /** A right-aligned control on the heading row — a filter, a "View all"
   * link. */
  action?: React.ReactNode
  children: React.ReactNode
  /** "card" (default) wraps the body in one bordered white card, matching
   * "Needs your attention" / "Recent documents". "plain" puts the heading
   * directly on the canvas with no wrapping border, matching "My projects",
   * whose children are their own separate cards. */
  variant?: "card" | "plain"
  className?: string
}

/** The one section-heading pattern every portal module shares: a 20px
 * semibold title, an optional real count badge, and an optional action on
 * the same row. */
export function PortalSection({
  title,
  count,
  action,
  children,
  variant = "card",
  className
}: PortalSectionProps) {
  return (
    <section className={cn("flex flex-col gap-3", className)}>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <h2 className="text-left text-xl font-semibold text-gray-900">
            {title}
          </h2>
          {typeof count === "number" && count > 0 && (
            <Badge count={count} color="#D97706" />
          )}
        </div>
        {action}
      </div>
      {variant === "card" ? (
        <CardComponent styles={{ body: { padding: 20 } }}>
          {children}
        </CardComponent>
      ) : (
        children
      )}
    </section>
  )
}
